import axiosInstance from '../../api/axiosInstance';

export const GetAddedFundList = async () => {
    const uid = localStorage.getItem("uid")
    const response = await axiosInstance.get(`/inv-user-fund?userId=${uid}`);
    return response.data;
};

export const AddFund = async (payload) => {
    const response = await axiosInstance.post('/inv-user-fund', payload);
    return response.data;
};

export const DeleteFund = async (payload) => {
    const response = await axiosInstance.delete(`/inv-user-fund/${payload}`);
    return response.data;
};

export const AddAllocationFund = async (payload) => {
    const response = await axiosInstance.post(`/inv-user-fund/allocate-fund/${localStorage.getItem("allocationId")}`, payload);
    return response.data;
};

export const UserActivePortfolio = async (payload) => {
    const response = await axiosInstance.get(`/inv-portfolio/active?userId=${localStorage.getItem("uid")}`);
    return response.data;
};

export const CheckAllocation = async (payload) => {
    const response = await axiosInstance.get(`/inv-user-fund/check-allocation/${localStorage.getItem("allocationId")}`);
    return response.data;
};
export const GetAllocatedStockList = async (payload) => {
    const response = await axiosInstance.get(`/inv-user-fund/${localStorage.getItem("allocationId")}/stocks`);
    return response.data;
};